import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { HeroSection } from "../components/HeroSection";
import { AboutSection } from "../components/AboutSection";
import { AreasSection } from "../components/AreasSection";
import { DifferentialsSection } from "../components/DifferentialsSection";
import { TestimonialsSection } from "../components/TestimonialsSection";
import { FormSection } from "../components/FormSection";

const HEADER_OFFSET = 96;

export function HomePage() {
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) return undefined;

    const id = location.hash.slice(1);
    let attempts = 0;
    let timeoutId;

    const tryScroll = () => {
      const el = document.getElementById(id);
      if (el) {
        const top = el.getBoundingClientRect().top + window.scrollY - HEADER_OFFSET;
        window.scrollTo({ top, behavior: "smooth" });
      } else if (attempts < 30) {
        attempts += 1;
        timeoutId = setTimeout(tryScroll, 50);
      }
    };

    tryScroll();

    return () => {
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [location]);

  return (
    <main>
      <HeroSection />
      <AboutSection />
      <AreasSection />
      <DifferentialsSection />
      <TestimonialsSection />
      <FormSection />
    </main>
  );
}
